import React from 'react';

import { SvgIcon, SvgIconProps } from '@mui/material';

const Ratio1: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props}>
      <rect
        width="2"
        height="8"
        transform="matrix(-1 0 0 1 4 8)"
        fillOpacity="0.87"
      />
      <rect
        width="2"
        height="8"
        transform="matrix(-1 0 0 1 22 8)"
        fillOpacity="0.87"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 5H8V19H16V5ZM6 3V21H18V3H6Z"
        fillOpacity="0.87"
      />
    </SvgIcon>
  );
};

export default Ratio1;
